<template>
  <div class="cookie-policy" v-loading="loading">
    <h1 class="head">cookie policy</h1>
    <div class="main">
      <h2>YOUR COOKIE PREFERENCES</h2>
      <p>
        We use cookies that are necessary to provide the Mini World: CREATA. We
        would also like to use other cookies to improve your experience, which we
        and our third party partners would access, to allow Mini World: CREATA to
        function optimally for you and to analyse its performance, including to
        improve Mini World: CREATA. We won’t use any non-essential cookies without
        your consent.
      </p>
      <p>
        Please review our cookie policy for more information about the cookies we
        and third parties use and your options, <a class="reset-a" href="javascript:;" @click="goDetail">here</a>.
      </p>
      <p class="btns">
        <a><el-button class="btn" type="primary" @click="acceptAllCookies">Accept all optional cookies</el-button></a>
        <a><el-button class="btn" type="danger" @click="rejectAllCookies">Reject all optional cookies</el-button></a>
        <a href="#setCookie"><el-button class="btn" type="success">Set cookie preferences</el-button></a>
      </p>
      <p>
        You can adjust your preferences at any time by going to the privacy
        section of this website by clicking the link at the bottom of any website
        page.
      </p>
      <p>
        For more information on our cookie policy, please click
        <a class="reset-a" href="javascript:;" @click="goDetail">here</a>.
      </p>
      <h2>What is a cookie?</h2>
      <p>
        A cookie is a small text file that is stored in a dedicated location on
        your computer, tablet, smartphone or other device when you use your
        browser to visit an online service. A cookie allows its sender to identify
        the device on which it is stored during the period of validity of consent.
        You may accept or reject the cookies listed below using the check box
        provided.
      </p>
      <p>
        <el-checkbox v-model="checked1" disabled>Cookies necessary for service (non-optional)</el-checkbox>
      </p>
      <p>
        These cookies are essential to provide you with the Website and to use
        some of its features such as secure the Website and your information, and
        prevent fraudulent and/or criminal hacking or other suspect activities and
        attacks.
      </p>
      <p>
        <el-checkbox v-model="checked2"><a name="setCookie">Functionality cookies</a></el-checkbox>
      </p>
      <p>
        Functionality cookies record information about choices you have made and
        allow us to tailor the Website to you. These cookies mean that when you
        continue to use or come back to use the Website, we can provide you with
        our services as you have asked for them to be provided.
      </p>
      <p>
        <el-table :data="table1" border empty-text="none" header-cell-class-name="gery" row-class-name="gery">
          <el-table-column
            prop="cookieName"
            label="cookie name"
          ></el-table-column>
          <el-table-column prop="purpose" label="purpose"></el-table-column>
        </el-table>
      </p>
      <p>
        <el-checkbox v-model="checked3">Performance and analytics cookies</el-checkbox>
      </p>
      <p>
        We use performance / analytics cookies to analyse how the Website is
        accessed, used or performing in order to provide you with a better user
        experience and to maintain, operate and continually improve the Website.
        For example, these cookies allow us to analyse user habits, ascertain the
        number of page views and unique visitors and conduct research and
        diagnostics to improve product offerings and functions.
      </p>
      <p>
        <el-table :data="table2" border empty-text="none" header-cell-class-name="gery" row-class-name="gery">
          <el-table-column
            prop="cookieName"
            label="cookie name"
          ></el-table-column>
          <el-table-column prop="purpose" label="purpose"></el-table-column>
        </el-table>
      </p>
      <!-- 没有做广告推广 -->
      <!-- <p>
        <el-checkbox v-model="checked4">Advertising and targeting cookies</el-checkbox>
      </p>
      <p>
        These cookies enable such companies to track your activity across various
        sites where they display advertisements and record your activities so they
        can show advertisements that they consider relevant to you as you browse
        the Internet.
      </p>
      <p>
        <el-table :data="table3" stripe border empty-text="none" header-cell-class-name="gery" row-class-name="gery">
          <el-table-column
            prop="cookieName"
            label="cookie name"
          ></el-table-column>
          <el-table-column prop="purpose" label="purpose"></el-table-column>
        </el-table>
      </p> -->
      <p>
        <el-button type="danger" @click="back">Back</el-button>
        <el-button type="primary" @click="save">Save</el-button>
      </p>
      <p>
        You can adjust your preferences at any time by going to the privacy section of this website by clicking the link at the bottom of any [<a class="reset-a" href="https://www.miniworldgame.com/cookiepolicy/">https://www.miniworldgame.com/cookiepolicy/</a>] website page. For more information on our cookie policy, please click  <a class="reset-a" href="javascript:;" @click="goDetail">here</a>.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      loading: false,
      checked1: true,
      checked2: false,
      checked3: false,
      checked4: false,
      table1: [
        {
          cookieName: "_icl_current_language",
          purpose: "To record selected languages of users",
        },
        {
          cookieName: "sso_token",
          purpose: "Cache data to improve user experience",
        },
      ],
      table2: [
        {
          cookieName: "_gat",
          purpose: "Track and analyze user behavior to provide a better service.",
        },
        {
          cookieName: "_gid",
          purpose: "Track and analyze user behavior to provide a better service.",
        },
        {
          cookieName: "_ga",
          purpose: "Track and analyze user behavior to provide a better service.",
        }
      ],
      table3: [],
    };
  },
  methods: {
    acceptAllCookies() {
      this.checked2 = true
      this.checked3 = true
      this.checked4 = true
    },
    rejectAllCookies() {
      this.checked2 = false
      this.checked3 = false
      this.checked4 = false
    },
    save() {
      this.loading = true
      setTimeout(() => {
        this.loading = false
        this.$message.success('success')
      }, 2000)
    },
    back() {
      if (document.referrer === '') {
        window.location.href = '/'
      } else {
        window.history.go(-1)
      }
    },
    goDetail() {
      if (process.env.NODE_ENV === 'development') {
        window.location.href = 'https://www.miniworldgame.com/mini-world-creata-cookies-policy/'
      } else {
        window.location.href = '/mini-world-creata-cookies-policy/'
      }
    }
  }
};
</script>

<style>
.el-table {
  background-color: #ddd !important;
}
.el-table .gery {
  background-color: #ddd !important;
}
.el-table--enable-row-hover .el-table__body tr:hover>td{
  background-color: #e5e5e5 !important;
}
.el-checkbox.is-disabled .el-checkbox__label {
  color: #333 !important;
}
</style>
<style scoped>
.cookie-policy {
  max-width: 1000px;
  margin: auto;
  color: #333;
  background-color: #ddd;
  border-radius: 5px;
  margin-top: 30px;
}
.cookie-policy .head {
  width: 100%;
  height: 67px;
  color: #fff;
  text-align: center;
  font-size: 28px;
  line-height: 67px;
  background: url(//cdn-mnweb.miniworldgame.com/assets/images/g_section_bg.png) no-repeat top;
}
.cookie-policy .main {
  padding: 0 20px 20px;
}
.cookie-policy .btns .btn {
  margin: 5px;
}
.cookie-policy .reset-a {
  text-decoration: underline;
  color: blue !important;
}
</style>
